!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("@material-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "@material-ui/core"], t) : t((e = e || self)["ant-switch"] = {}, e.core);
}(this, function (e, t) {
  "use strict";

  var o = t.withStyles(function (e) {
    return t.createStyles({
      root: {
        width: 28,
        height: 16,
        padding: 0,
        margin: 8,
        display: "flex"
      },
      switchBase: {
        padding: 2,
        color: e.palette.grey[500],
        "&$checked": {
          transform: "translateX(12px)",
          color: e.palette.common.white,
          "& + $track": {
            opacity: 1,
            backgroundColor: e.palette.primary.main,
            borderColor: e.palette.primary.main
          }
        }
      },
      thumb: {
        width: 12,
        height: 12,
        boxShadow: "none"
      },
      track: {
        border: "1px solid " + e.palette.grey[500],
        borderRadius: 8,
        opacity: 1,
        backgroundColor: e.palette.common.white,
        boxSizing: "border-box"
      },
      checked: {}
    });
  })(t.Switch);
  e.AntSwitch = o, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});